import { ArticleSearchHeader } from "../components/article-search-header";

const test = ({ __typename }: { __typename: string }): boolean =>
  __typename === "VinoData_ArticleSearchHeader";

const create = (data): JSX.Element => {
  return <ArticleSearchHeader {...data} />;
};

export default { test, create };
